import React, { useEffect, useRef, useState } from 'react';
import './NavBar.css';
import { RiHome2Line } from 'react-icons/ri';
import { GiMoneyStack } from 'react-icons/gi';
import { IoIosContact } from 'react-icons/io';
import { FiMenu, FiX } from 'react-icons/fi';
import logo from '../assets/img/logo-cootraespeciales.svg';

const NAV_LINKS = [
  { href: '#home', label: 'Inicio', icon: RiHome2Line },
  { href: '#cotizar', label: 'Cotizar', icon: GiMoneyStack },
  { href: '#contact', label: 'Contacto', icon: IoIosContact },
];

const NavBar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeHref, setActiveHref] = useState('#home');
  const menuRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const sections = NAV_LINKS
      .map(({ href }) => document.querySelector(href))
      .filter(Boolean);

    if (sections.length === 0) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) {
          setActiveHref(`#${visible.target.id}`);
        }
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isMenuOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') setIsMenuOpen(false);
    };
    const onClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('mousedown', onClickOutside);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('mousedown', onClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <nav
      ref={menuRef}
      className={`navbar${isScrolled ? ' navbar--scrolled' : ''}${isMenuOpen ? ' navbar--open' : ''}`}
    >
      <div className="navbar-inner">
        <a href="#home" className="navbar-brand" onClick={() => setIsMenuOpen(false)}>
          <img src={logo} alt="Cootraespeciales" />
        </a>

        <button
          type="button"
          className="navbar-toggle"
          aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          {isMenuOpen ? <FiX /> : <FiMenu />}
        </button>

        <ul className="navbar-links">
          {NAV_LINKS.map(({ href, label, icon: Icon }) => (
            <li key={href}>
              <a
                href={href}
                className={activeHref === href ? 'is-active' : ''}
                aria-current={activeHref === href ? 'page' : undefined}
                onClick={() => setIsMenuOpen(false)}
              >
                <Icon className="navbar-link-icon" aria-hidden="true" />
                <span>{label}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default NavBar;
